import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import { Suspense, lazy } from 'preact/compat';
const TarotReadingQuestion = lazy(
    () => import(/* webpackChunkName: "tarot-reading-question" */ '../tarot-reading/question')
);
const TarotReadingDeckSelect = lazy(
    () => import(/* webpackChunkName: "deck-select" */ '../tarot-reading/deck-select')
);
import TarotReadingShuffle from '../tarot-reading/shuffle';
import TarotReadingDeckHeader from '../tarot-reading/deck-header';
import TarotReadingDeck from '../tarot-reading/deck';
import TarotSpread from './tarot-spread';
import { smoothScrollToElement } from '../../shared/scroll';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.init(props.upc, props.type);
        this.state = { accordionOpen: false };
        this.isOneCardReading = props.upc.match(/-1-card/);
    }

    componentDidMount() {
        if (!this.props.deck) {
            this.props.requireDeck();
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.spread != this.props.spread) {
            return true;
        }

        if (nextProps.deck != this.props.deck) {
            return true;
        }

        if (nextProps.sample_interps != this.props.sample_interps) {
            return true;
        }

        if (nextProps.user != this.props.user) {
            return true;
        }

        if (nextProps.button_text != this.props.button_text) {
            return true;
        }

        if (nextProps.error != this.props.error) {
            return true;
        }

        if (nextProps.completed != this.props.completed) {
            return true;
        }

        if (nextProps.report != this.props.report) {
            return true;
        }

        return false;
    }

    render({ upc, deck, button_text, spread, teeup, completed, product }) {
        let view = null;

        if (upc == 'yes-or-no-tarot-redux') {
            view = spread && spread.length == 8 ? 'view-2' : 'view-1';
        }

        if (deck && !this.isOneCardReading) {
            return (
                <tarot-teeup upc={upc} view={view}>
                    <div>
                        <Suspense fallback={<div className='skeleton' />}>
                            <TarotReadingQuestion />
                        </Suspense>
                    </div>
                    <section>
                        <TarotReadingShuffle upc={upc} />
                        <TarotReadingDeckHeader upc={upc} />
                        <TarotReadingDeck upc={upc} view={view} />
                        <Suspense fallback={<div className='skeleton' />}>
                            <TarotReadingDeckSelect deck={deck} />
                        </Suspense>
                    </section>
                    <TarotSpread view={view} />
                    {this.renderError()}
                    <form onSubmit={this.reveal}>
                        <div className='button-wrapper'>
                            <button
                                className={completed ? 'button-warning' : 'disabled button-warning'}
                                data-action={
                                    button_text == 'shuffle cards'
                                        ? 'Click-Shuffle-Cards-Button'
                                        : 'Click-Reveal-Meaning-Button'
                                }
                            >
                                {button_text}
                            </button>
                        </div>
                    </form>
                    {this.renderContent()}
                </tarot-teeup>
            );
        } else if (deck && teeup) {
            return (
                <tarot-teeup upc={upc} view={view}>
                    <section className='is-hidden'>
                        <TarotReadingDeck upc={upc} view={view} />
                    </section>
                    <TarotSpread view={view} />
                    {this.renderError()}
                    <form onSubmit={this.reveal}>
                        {!product.submitted &&
                            <div className='button-wrapper has-margin-30-top'>
                                <button
                                    className={completed ? 'button-pink-alternate' : 'disabled button-pink-alternate'}
                                >
                                    {button_text}
                                </button>
                            </div>
                        }
                    </form>
                </tarot-teeup>
            );
        }

        return (
            <tarot-teeup upc={upc} view={view} />
        );
    }

    renderContent = () => {
        if (this.props.teeup && this.props.teeup.long_description && this.props.showContent) {
            return (
                <div className='details has-margin-60-top'>
                    <h2 className='has-margin-15-bottom'>About This {this.props.teeup.display_name}</h2>
                    <summary>
                        {this.props.teeup.long_description.map((section) => (this.renderSummaryP(section)))}
                    </summary>
                    <br />
                    {this.renderCardDescriptions()}
                    <row className='is-justified-center has-margin-30-top'>
                        <column>
                            <a href='' className='button button-warning-simple' onClick={(e) => this.goTo(e, 'main')}>
                                START MY READING
                            </a>
                        </column>
                    </row>
                </div>
            );
        }

        return null;
    }

    renderCardDescriptions = () => {
        const positions = this.props.teeup && this.props.teeup.fields && this.props.teeup.fields[2]
            && this.props.teeup.fields[2].positions;

        if (
            ! [
                'yes-or-no-tarot-redux',
                'two-hearts-tarot-redux',
            ].includes(this.props.upc)
            &&
            positions && positions[0] && positions[0].title
        ) {
            return [
                <h2>
                    {this.props.showContent ? 'Tarot Card Positions' : 'Card Descriptions'}
                </h2>,
                <dl>
                    {positions.map((position) => (this.renderPosition(position)))}
                </dl>,
            ];
        }

        return null;
    }

    renderSummaryP = (section) => {
        if (section) {
            return (<p dangerouslySetInnerHTML={{ __html: section }} />);
        }

        return null;
    }

    renderPosition = (position) => {
        if (position.title && position.short_description) {
            /* eslint-disable react/no-unknown-property */
            /* unknown-property: no-reorder */
            return (
                <virtual no-reorder>
                    <dt>{position.title}: </dt>
                    <dd>{position.short_description}</dd>
                    <br />
                </virtual>
            );
            /* eslint-enable react/no-unknown-property */
        }

        return null;
    }

    renderError = () => {
        if (this.props.error && this.props.error.question) {
            return (
                <div className='error'>
                    <p className='show'>{this.props.error.question}</p>
                </div>
            );
        } else if (this.props.error) {
            return (
                <div className='error'>
                    <p className={this.props.error.remaining ? 'show' : ''}>
                        {this.isOneCardReading
                            ? 'Please choose your card first.'
                            : `Please choose ${this.props.error.remaining} more ${parseInt(this.props.error.remaining,
                                10) > 1 ? 'cards' : 'card'} from the deck above first.`
                        }
                    </p>
                </div>
            );
        }

        return null;
    }

    reveal = (e) => {
        e.preventDefault();
        this.trackEvent(
            this.props.button_text == 'shuffle cards' ? 'Shuffle Cards' : 'Reveal Meaning'
        );

        if (this.props.upc == 'yes-or-no-tarot-redux' && this.props.completed) {
            if (this.props.view == 'view-1') { //moving from view 1 to view 2
                //set spread to picked_cards (shuffled)
                let cards = this.props.picked_cards;

                if (cards[0] != 10) {
                    cards[0] = 10;
                }

                cards = _.shuffle(cards);

                this.props.updateSpread(cards);

                //set tarot-reading.button_text to 'reveal the meaning'
                this.props.buttonText('reveal the meaning');

                //empty tarot-reading.cards
                this.props.cards([]);

                //hide 'choose a deck' select input
                document.querySelector('tarot-reading select').style.display = 'none';

                //set question subject, in new p.subject-set
                const questionP = document.querySelector('tarot-question p.subject'); //old p.subject
                if (questionP) {
                    questionP.style.display = 'none';
                }

                const questionInput = document.querySelector('tarot-question input'); //old question input
                if (questionInput) {
                    questionInput.style.display = 'none';
                }

                //new question p
                const subjectP = document.createElement('p');
                subjectP.classList.add('subject-set');
                subjectP.innerHTML = 'Your Question: ' + this.props.subject;

                //add new question p to tarot-question element
                document.querySelector('tarot-question').appendChild(subjectP);

                //remove subheadline and 'Learn More' link
                document.querySelector('tarot-reading header > p').style.display = 'none';

                return false;
            }
        }

        this.props.trackCheckoutEvent({
            event: 'add_to_cart',
            upc: this.props.upc,
            name: this.props.product.teeup.display_name,
        });

        this.props.fetch();
        return false;
    }

    goTo = (e, chapter) => {
        e.preventDefault();
        smoothScrollToElement(document.querySelector(chapter));
    }

    trackEvent = (label) => {
        this.props.trackEvent([
            'Tarot Readings',
            'Click',
            label,
            `Readings_${this.props.upc}:${label}`,
        ]);
    }
}

const mapStateToProps = (state) => ({
    button_text: state.product && state.product.submitting ? 'submitting…' : state['tarot-reading'].button_text,
    completed: state.product && state.product.teeup && state.product.teeup.fields && state.product.teeup.fields[2]
        && state['tarot-reading'] && state['tarot-reading'].cards
        && state.product.teeup.fields[2].positions.length === state['tarot-reading'].cards.length,
    deck: state.deck,
    error: state['tarot-reading'].error,
    logged_in: state.user && state.user.logged_in,
    picked_cards: state['tarot-reading'].cards,
    teeup: state.product.teeup,
    upsell_upc: state.product.teeup && state.product.teeup.upsell_upc,
    subject: state['tarot-reading'].subject || 'Unspoken',
    showContent: state.product && state.product.description && state.product.description.code
        && ['celtic-cross-sample', 'celtic-cross-love-sample'].includes(state.product.description.code),
    spread: state.spread,
    sample_interps: state['tarot-reading'].interps,
    report: state.report,
    product: state.product,
});

const mapDispatchToProps = (dispatch) => ({
    init: (upc) => dispatch({
        type: 'tarot-reading:init',
        payload: {
            upc: upc,
        },
    }),
    requireDeck: () => dispatch({ type: 'deck:required', payload: 'universal_waite' }),
    fetch: () => dispatch({ type: 'tarot-reading:fetch' }),
    trackCheckoutEvent: (action) => dispatch({ type: 'ga:checkout_event', payload: action }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    updateSpread: (payload) => dispatch({
        type: 'spread:update',
        payload: payload,
    }),
    buttonText: (payload) => dispatch({
        type: 'tarot-reading:update',
        payload: {
            button_text: payload,
        },
    }),
    cards: (payload) => dispatch({
        type: 'tarot-reading:update',
        payload: {
            cards: payload,
        },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
